module.exports = __webpack_public_path__ + "img/jyzt-bg-new.9c86a834.png";